<template>
    <div class="p-0-18">
        <div class="ibox-content product-class border-none"
             :id="`product_item_${service.service_id}_${service.clone}_custom_${componentCounter}`">
            <div class="">
                <div class="appointment-header">Custom product</div>
                <input type="hidden" :name="`product_custom_${service.service_id}_${service.clone}[]`" value="1">

                <div class="float-right">
                    <a href="javascript:void(0)"
                       @click="removeCustomProduct">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
                                fill="#E0E2E5"/>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="m-top-20">
                <div class="row">
                    <div class="product-inputs col-md-6">
                        <label class="label-form m-bottom-12">Description</label>
                        <input type="text" :name="`product_${service.service_id}_${service.clone}[]`"
                               class="product-new-input form-control" v-model="product.description"/>
                    </div>
                </div>
            </div>
            <div class="m-top-20 mobile-remove-m-top">
                <div class="row">
                    <div class="product-inputs col-md-6">
                        <label
                            class="label-form m-bottom-12">Quantity</label>

                        <input type="number" step="0.01" :name="`custom_product_qty_${service.service_id}_${service.clone}[]`"
                               :id="`custom_product_qty_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                               class="product-new-input form-control" v-model="product.quantity"
                               @blur="toFloat" @keypress="checkNumeric($event)" novalidate/>
                    </div>

                    <div class="product-inputs col-md-6">
                        <label class="label-form m-bottom-12">Cost Per Unit {{ currency.currency_symbol }}</label>

                        <div class="input-group">
                            <span class="input-group-addon input-group-addon-new-design"
                                  style="background-color: #F5F5F6 !important;">
                                <b> {{ currency.currency_symbol }} </b>
                            </span>
                            <input type="number" step="0.01" class="product-new-input form-control number_only width-211"
                                   :name="`custom_product_cost_${service.service_id}_${service.clone}[]`"
                                   :id="`custom_product_cost_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                   v-model="product.costPricePerUnit" @keypress="checkNumeric($event)"
                                   @blur="toFloat"/>
                        </div>
                    </div>

                    <div class="product-inputs col-md-6 m-top-10">
                        <label class="label-form m-bottom-12">Markup Per Unit</label>
                        <div class="input-group">
                            <span class="input-group-addon input-group-addon-new-design"
                                  style="background-color: #F5F5F6 !important;">
                                <b> {{ currency.currency_symbol }} </b>
                            </span>

                            <input readonly type="text" class="product-new-input form-control" :value="markup"
                                   :name="`custom_product_markup_${service.service_id}_${service.clone}[]`"
                                   :id="`custom_product_markup_${service.service_id}_${service.clone}_custom_${componentCounter}`"/>

                            <span class="input-group-addon input-group-addon-new-design-right">
                                <select
                                    :name="`custom_product_markup_type_${service.service_id}_${service.clone}[]`"
                                    :id="`custom_product_markup_type_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                    v-model="product.markupType"
                                    class="ipad-m-top-0"
                                    style="border: none; background-color: white">
                                <option value="%" label="%">%</option>
                                <option :value="currency.currency_symbol"
                                        :label="currency.currency_symbol">{{ currency.currency_symbol }}</option>
                                </select>
                            </span>
                        </div>
                    </div>
                    <div class="product-inputs col-md-6 m-top-10">
                        <label class="label-form m-bottom-12">Sale Price Per Unit</label>

                        <div class="input-group">
                            <span class="input-group-addon input-group-addon-new-design"
                                  style="background-color: #F5F5F6 !important;">
                                <b> {{ currency.currency_symbol }} </b>
                            </span>
                            <input type="number" step="0.01"
                                   :name="`custom_product_sale_price_${service.service_id}_${service.clone}[]`"
                                   :id="`custom_product_sale_price_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                   :class="`product-new-input form-control width-211 product_sale_price_${service.service_id}_${service.clone}`"
                                   v-model="product.salePricePerUnit"
                                   @keypress="checkNumeric($event)"
                                   @blur="toFloat"
                                   style="border-radius: 0px 8px 8px 0px;"/>
                            <input type="hidden"
                                   :name="`custom_product_tax_${service.service_id}_${service.clone}[]`"
                                   :id="`product_tax_34617_${service.service_id}_${service.clone}_custom_${componentCounter}`" value="">
                        </div>
                    </div>
                    <div class="product-inputs col-md-6 m-top-10">
                        <label class="label-form m-bottom-12">Discount</label>

                        <div class="input-group">
                            <input type="number" step="0.01"
                                   :name="`custom_product_discount_${service.service_id}_${service.clone}[]`"
                                   :id="`product_discount_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                   @blur="toFloat" v-model="product.discount"
                                   @keypress="checkNumeric($event)"
                                   class="product-new-input form-control"/>
                            <span class="input-group-addon input-group-addon-new-design-right">
                                <select
                                    :id="'custom_product_discount_type_' + service.service_id + '_' + service.clone + '_' + componentCounter"
                                    :name="'custom_product_discount_type_' + service.service_id + '_' +service.clone + '[]'"
                                    class="ipad-m-top-0"
                                    v-model="product.discountType"
                                    style="border: none; background-color: white">
                                    <option :value="currency.currency_symbol">
                                        {{ currency.currency_symbol }}
                                    </option>
                                    <option value="%">%</option>
                                </select>
                            </span>
                        </div>
                    </div>

                    <div class="product-inputs col-md-6 m-top-10" v-if="service.for_products !== 1">
                        <label class="label-form m-bottom-12">Supplied By</label>
                        <select :name="`custom_supplied_by_${service.service_id}_${service.clone}[]`" id="supplied_by"
                                class="product-new-input form-control">
                            <option value="company" :data-tax-rate="`custom_${componentCounter}`"
                                    label="Supplied by company">Company
                            </option>
                            <option value="fieldworker" :data-tax-rate="`custom_${componentCounter}`"
                                    label="Supplied by fieldworker">Fieldworker
                            </option>
                        </select>
                    </div>
                    <div class="product-inputs col-md-6 m-top-10">
                        <label class="label-form m-bottom-12">Sub Total</label>
                        <div class="input-group">
                        <span class="input-group-addon input-group-addon-new-design"
                              style="background-color: #F5F5F6 !important;">
                            <b> {{ currency.currency_symbol }} </b>
                        </span>
                            <input readonly type="number"
                                   :name="`custom_product_subtotal_${service.service_id}_${service.clone}[]`"
                                   :class="`product-new-input form-control width-211 product_subtotal_${service.service_id}_${service.clone}`"
                                   :id="`product_subtotal_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                   :value="subTotal"
                                   @blur="toFloat"
                                   style="    border-radius: 0px 8px 8px 0px;"/>
                        </div>
                    </div>
                    <div v-if="service.showTaxRate && service.for_products === 1"
                         class="m-top-10 product-inputs col-md-6 product-inputs ipad-padding-top-12">
                        <label class="label-form m-bottom-12">Tax Rate (%)</label>
                        <select :name="`custom_product_tax_id_${service.service_id}_${service.clone}[]`"
                                :id="`custom_product_tax_id_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                class="product-new-input form-control"
                                v-model="taxSelected"
                                @change="handleSelectionChange">
                            <option v-if="taxOptions.length > 0" value="isNew" label="+ Add new tax rate">+ Add new tax rate</option>
                            <option v-for="option of taxOptions" :value="option">
                                {{ option.tax_rate_name }} ({{ option.tax_rate_value }}%)
                            </option>
                        </select>
                        <div v-if="taxSelected && taxSelected.hasOwnProperty('tax_rate_id')" class="display-none">
                            <input type="hidden"
                                   :id="`product_tax_${service.service_id}_${service.clone}_custom_${componentCounter}`"
                                   :name="`custom_product_tax_${service.service_id}_${service.clone}[]`" :value="taxSelected.tax_rate_value">
                        </div>
                    </div>
                    <tax-rate-popup  :component-counter="componentCounter" :id="modalId"></tax-rate-popup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getTaxRateOptions} from "@/modules/Services/api/billing"
import TaxRatePopup from "@/modules/Services/components/billing/types/TaxRatePopup.vue";
import alert from "bootstrap/js/src/alert";

export default {
    name: "CustomProduct",
    components: {TaxRatePopup},
    props: {
        service: {
            type: Object,
            required: true
        },
        currency: {
            type: Object,
            required: true
        },
        componentCounter: {
            required: true
        },
        product: {
            required: true
        },

    },
    data() {
        return {
            taxOptions:[],
            taxSelected:[],
        }
    },
    methods: {
        listenToNewTaxRateOptionAdded(){
            this.product.quantity =(1).toFixed(2)
            EventBus.$on('newTaxRateOptionAdded', newOption => {
                    this.taxOptions.push(newOption)
                    this.taxSelected = newOption
            })
        },
        loadTaxOptions() {
            if(this.service?.taxRatesOptions?.length ){
                this.taxOptions = this.service.taxRatesOptions;
                if ( this.service.tax_rate.tax_rate_id){
                    this.taxSelected = this.taxOptions.find(option => option.tax_rate_id == this.service.tax_rate.tax_rate_id)
                }else{
                    this.taxSelected =  this.taxOptions[0];
                }
            }else{
                getTaxRateOptions(this.service.service_id)
                    .then(response => {
                        this.taxOptions = response.data
                        if ( this.service.tax_rate.tax_rate_id){
                            this.taxSelected = this.taxOptions.find(option => option.tax_rate_id == this.service.tax_rate.tax_rate_id)
                        }else{
                            this.taxSelected =  this.taxOptions[0];
                        }
                    })
            }

        },
        handleSelectionChange(){
            if ( this.taxSelected &&  this.taxSelected == 'isNew') {
                let id = this.modalId;
                $("#" + id).modal("show")
            }
        },
        checkNumeric(event) {
            var charCode = (event.which) ? event.which : event.keyCode;
            if ((charCode < 48 || charCode > 57)&& charCode!=46) { // ASCII values for 0-9,decimal point
                event.preventDefault();
            }
        },
        toFloat(event) {
            if (event.target.value) {
                event.target.value = parseFloat(event.target.value).toFixed(2)
                return
            }
            event.target.value = parseFloat(0).toFixed(2)
        },

        removeCustomProduct() {
            EventBus.$emit('onCustomProductDelete', this.componentCounter, this.service.service_id,this.service.clone)
        }
    },
    mounted() {
        this.listenToNewTaxRateOptionAdded();
        this.loadTaxOptions();
    },
    computed: {
        markup() {
            let markup = 0;

            if (this.product.markupType === '%') {
                markup = (100 * (parseFloat(this.product.salePricePerUnit) - parseFloat(this.product.costPricePerUnit))) / parseFloat(this.product.costPricePerUnit);
            } else {
                markup = this.product.salePricePerUnit - parseFloat(this.product.costPricePerUnit);   //new equation
            }

            return Number.isNaN(markup) || !Number.isFinite(markup) ? 0 : markup


        },
        subTotal() {
            let price = this.product.salePricePerUnit * this.product.quantity;

            if (this.product.discountType === "%") {
                return parseFloat(price - (price * (+this.product.discount / 100))).toFixed(2)
            }

            return parseFloat(price - +this.product.discount).toFixed(2)
        },
        modalId() {
            if (parseInt(this.service.clone)) {
                return `add-tax-rate-popup_${this.service.service_id}_${this.service.clone}`;
            }
            return `add-tax-rate-popup_${this.service.service_id}`;
        },

    },
    watch: {
        product: {
            handler: function (product) {
                this.$emit('input', product)
            },
            deep: true
        },
        subTotal(value) {
            this.product.subTotal = +value
            this.$emit('input', this.product)
        },
        taxSelected(value){
            this.product.taxRate = value;
            this.$emit('input', this.product)
        }
    }
}
</script>

<style scoped>

</style>